import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import Moment from 'react-moment';
import Avatar from 'react-avatar';

import { database } from '../Firebase/firebase';
import { isUserAllowed } from '../Constants/Functions';
import { firebaseCollections } from '../Constants/Variables';
import AppModal from './AppModal';

import '../Styles/Components/Comment.scss';

export default function Comment(props) {

    const [removePostCommentModalShown, setRemovePostCommentModalShown] = useState(false);

    var post = props.post;
    var comments = props.comments;
    var comment = props.comment;
    var account = props.account;
    var fbaccount = props.fbaccount;

    const removePostCommentHandler = (commentId) => {
        var newCommentsArr = comments.filter((comment) => {
            return comment.id !== commentId;
        });
        post.comments = newCommentsArr;
        console.log(commentId);
        console.log(comments);
        //Update Comment in Firebase Post Doc
        database.collection(firebaseCollections.thewall).doc(post.id).update({ comments: post.comments }).then(function () {
            console.log("Finished updating a new comment to a feedback post in firebase db.");
        })
            .catch(function (error) {
                console.error("Error adding document: ", error);
            });
    }

    const hidePostCommentRemovePrompt = () => {
        setRemovePostCommentModalShown(false);
    }

    return (
        <div>
            <div className="Comment">
                <div className="Comment--Message">
                    <Avatar name={comment.user.name} round={true} textSizeRatio={2.5} size="32px" color="White" maxInitials={2} className="AppNavbar--Profile-Container--Avatar Comment--Avatar" />
                    <span className="Comment--Text">{comment.message}
                        {
                            (comment.user.name === account.name || isUserAllowed(fbaccount.role, "deletePostComments")) ?
                                <Button className="App--primary-text-btn Comment--Remove-Btn" onClick={() => { setRemovePostCommentModalShown(true) }}><img src="/images/x_icon.png" alt="remove comment btn" /></Button> :
                                null
                        }
                    </span>
                </div>
                <span className="Comment--Timestamp"><Moment format="llll">{comment.timestamp.seconds ? comment.timestamp.toDate() : comment.timestamp}</Moment></span>
            </div>
            {
                removePostCommentModalShown ?
                    <AppModal onHide={hidePostCommentRemovePrompt} className="Post--RemovePostCommentModal">
                        <p className="Post--RemovePostCommentModal--Title">Remove Comment</p>
                        <p className="Post--RemovePostCommentModal--Text">You are about to remove a comment. Are you sure you want to proceed?</p>
                        <div className="Post--RemovePostCommentModal--Buttons">
                            <Button className="App--secondary-text-btn" onClick={() => { removePostCommentHandler(comment.id); setRemovePostCommentModalShown(false); }}>Yes</Button>
                            <Button className="App--primary-text-btn" onClick={() => { setRemovePostCommentModalShown(false) }}>No</Button>
                        </div>
                    </AppModal> :
                    null
            }
        </div>
    )
}
